var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.app.isSpinnerVisible)?_c('div',[(_vm.app.currentConfiguration.configurator.id=='30-esp_trabajo')?_c('configurator30-component'):_c('generic-configurator-component')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }